import React from 'react';
interface Props {
  fillColor?: string;
}
function RemedialMassageIcon({ fillColor = '#17385D' }: Props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="17"
      viewBox="0 0 18 17"
      fill="none">
      <path
        d="M9 3.12812C9.6625 3.90625 10.6281 5.30625 11.1438 7.33125C11.5594 7.00938 12 6.72188 12.4625 6.46875C11.6094 3.60625 9.98438 1.91875 9.4375 1.4125C9.31875 1.30313 9.1625 1.25 9.00313 1.25C8.84375 1.25 8.6875 1.30313 8.56875 1.4125C8.02188 1.91875 6.39687 3.60313 5.54375 6.46875C6.00625 6.72188 6.44688 7.00938 6.8625 7.33125C7.37813 5.30625 8.34063 3.90312 9.00625 3.12812H9ZM6 14.9094C6.71562 15.1188 7.46875 15.2375 8.25 15.25H9.75C10.5312 15.2375 11.2844 15.1219 12 14.9094C15.4688 13.8875 18 10.6781 18 6.87813C18 6.53125 17.7188 6.25 17.3719 6.25C15.4438 6.25 13.5688 6.80938 12 7.94063C10.6938 8.87813 9.65312 10.1594 9 11.65C8.34688 10.1594 7.30625 8.88125 6 7.94063C4.43125 6.80938 2.55625 6.25 0.628125 6.25C0.28125 6.25 0 6.53125 0 6.87813C0 10.6781 2.53125 13.8875 6 14.9094ZM6 13.3313C3.65 12.4656 1.9 10.35 1.55938 7.79375C3.28125 7.97812 4.82812 8.74688 6 9.89375C7.04688 10.9219 7.79375 12.2531 8.1 13.7437C7.36563 13.7156 6.65938 13.5719 6 13.3281V13.3313ZM12 13.3313C11.3406 13.5719 10.6375 13.7188 9.9 13.7469C10.2031 12.2531 10.9531 10.9219 12 9.89688C13.1719 8.74688 14.7187 7.98125 16.4406 7.79688C16.1 10.35 14.35 12.4656 12 13.3281V13.3313Z"
        fill={fillColor}
      />
    </svg>
  );
}

export default RemedialMassageIcon;
